import {
  RobotoNotFoundException,
  RobotoUnauthorizedException,
} from "@/shared/http";

/**
 * Why "Save to this View" failed, in the saver's terms.
 *
 * Unlike a shared link, the View was loaded on screen, so it was in the
 * caller's org: a 404 here means it was deleted since, and saying so is safe.
 * Both failures leave the filters on screen, so each message points at saving
 * them as a new View. Other domain errors carry a message written for the
 * caller and pass through.
 */
export function overwriteViewErrorMessage(error: unknown): string {
  if (error instanceof RobotoNotFoundException) {
    return "This view no longer exists. Create a new view to keep these changes.";
  }

  if (error instanceof RobotoUnauthorizedException) {
    return "You can't edit this view. Create a new view to keep these changes.";
  }

  return error instanceof Error ? error.message : "Could not save.";
}
